import { Mention } from "@tiptap/extension-mention";
import { PluginKey } from "@tiptap/pm/state";
import { createSuggestion } from "../components/Suggestion";
import { ApiQueryData } from "../../../../shared/_core/comments.types";

export const createUserMentionExtension = (
  getUserQuery: () => ApiQueryData,
) => {
  return Mention.extend({
    name: "userMention",
  }).configure({
    HTMLAttributes: { class: "mention" },
    suggestion: {
      char: "@",
      pluginKey: new PluginKey("userSuggestion"),
      ...createSuggestion(getUserQuery, "@"),
    },
    renderHTML({ node }) {
      return [
        "span",
        {
          class: "mention",
          "data-type": "mention",
          "data-id": node.attrs.id,
        },
        `@${node.attrs.label || node.attrs.id}`,
      ];
    },
  });
};

export const createSectionMentionExtension = (
  getSectionQuery: () => ApiQueryData,
) => {
  return Mention.extend({
    name: "sectionMention",
  }).configure({
    HTMLAttributes: { class: "section-link" },
    suggestion: {
      char: "/",
      pluginKey: new PluginKey("sectionSuggestion"),
      ...createSuggestion(getSectionQuery, "/"),
    },
    renderHTML({ node }) {
      return [
        "span",
        {
          class: "section-link",
          "data-type": "sectionLink",
          "data-id": node.attrs.id,
        },
        `/${node.attrs.label || node.attrs.id}`,
      ];
    },
  });
};
